const refineBy = [
  {
    value: 'www.un.org/sg',
  },
  {
    value: 'oios.un.org',
  },
  {
    value: 'www.un.org/ola',
  },
  {
    value: 'dppa.un.org',
  },
  {
    value: 'disarmament.unoda.org',
  },
  {
    value: 'peacekeeping.un.org',
  },
  {
    value: 'operationalsupport.un.org',
  },
  {
    value: 'www.unocha.org',
  },
  {
    value: 'www.un.org/dgacm',
  },
  {
    value: 'unite.un.org',
  },
  {
    value: 'un-dco.org',
  },
  {
    value: 'www.un.org/*/desa',
  },
  {
    value: 'www.un.org/*/department-global-communications',
  },
  {
    value: 'www.un.org/*/safety-and-security',
  },
  {
    value: 'www.un.org/management',
  },
  {
    value: 'www.un.org/ombudsman',
  },
  {
    value: 'www.un.org/*/internaljustice',
  },
  {
    value: 'news.un.org',
  },
  {
    value: 'press.un.org',
  },
  {
    value: 'media.un.org/photo',
  },
]

// const functionalCommission = [
//   {
//     value: '/ccpcj',
//   },
//   {
//     value: '/cnd',
//   },
//   {
//     value: '/stat',
//   },
//   {
//     value: '/women',
//   },
//   {
//     value: '/sustainabledevelopment',
//   },
//   {
//     value: '/forests',
//   },
// ]


const languageCode = [
  { value: 'ar' },
  { value: 'zh-cn' },
  { value: 'en' },
  { value: 'fr' },
  { value: 'ru' },
  { value: 'es' },
]




export function un() {
  return {
    refineBy,
    // functionalCommission,
    languageCode,
  }
}
